import { Row, TextBody } from "../lib";
import { createStyles } from "../theme";

type Props = {
  self: boolean;
  text: string;
};

export function ChatBubble({ text, self }: Props) {
  return (
    <Row style={[$.container, self ? $.self : $.other]}>
      <TextBody color={self ? "onAccent" : "onSurface"}>{text}</TextBody>
    </Row>
  );
}

const $ = createStyles({
  container: {
    py: "2",
    px: "3",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxWidth: 250,
  },
  self: {
    ml: "2",
    backgroundColor: "chatSecondary",
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 20,
  },
  other: {
    mr: "2",
    backgroundColor: "chatPrimary",
    borderBottomRightRadius: 20,
    borderBottomLeftRadius: 0,
  },
});
